export { default } from '@material-ui/core/Paper';

export type PaperProps = import('@material-ui/core/Paper').PaperProps;
